import { commonService } from '.';
import axios from "axios";
// postAsync
const APIURL = process.env.PUBLIC_URL + "/api";
const doActionsAsync = async (idUser, dateAction, comment, isTraining, isFromEa, idLang, data) => {
    const endpoint = 'Boond/actions?idUser=' + idUser + '&dateAction=' + dateAction + '&comment=' + comment + '&isTraining=' + isTraining + '&isFromEa=' + isFromEa + '&idLang=' + idLang + '&data=' + data;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, null);
};

const doRatesAsync = async (idUser, from, body) => {
    const endpoint = 'Boond/rates?idUser=' + idUser + '&from=' + from;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, body);
};

const doHighRatesAsync = async (idUser, body) => {
    const endpoint = 'Boond/highRates?idUser=' + idUser;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, body);
};

const uploadFileEAToBoond = (reference, idUser, year, idLang) => {
    return commonService.post('Boond/uploadFileToBoondEA?reference=' + reference + '&idUser=' + idUser + '&year=' + year + '&idLang=' + idLang);
};

const uploadFileDCToBoondAsync = async (reference, idDc, idLang, brand) => {
    const endpoint = 'Boond/uploadFileToBoondDC?reference=' + reference + '&idDc=' + idDc + '&idLang=' + idLang + '&brand=' + brand;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, null);
};

const getUserInfo = (idUser) => {
    return commonService.getWithParam('Boond/userInfo?idUser=' + idUser);
};

const sendEmailErrorSendBoond = async (idUser, apiLabel, error) => {
    const endpoint = 'Boond/sendEmailErrorSendBoond?idUser=' + idUser + '&apiLabel=' + apiLabel + '&error=' + error;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, null);
}

const resendDoActionsAsync = async (idUserConnected, idUser, dateAction, comment, isTraining, isFromEa, idLang, year, idBusinessManager) => {
    const endpoint = 'ResendBoond/actions?idUserConnected=' + idUserConnected + '&idUser=' + idUser + '&dateAction=' + dateAction + '&comment=' + comment + '&isTraining=' + isTraining + '&isFromEa=' + isFromEa + '&idLang=' + idLang + '&year=' + year + '&idBusinessManager=' + idBusinessManager;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, null);
};

const sendActivityAreas = async (idUser, body) => {
    const endpoint = 'Boond/activityAreas?idUser=' + idUser;
    const url = `${APIURL}/` + endpoint;
    return await axios.post(url, body);
};

export const boondService = {
    uploadFileEAToBoond,
    getUserInfo,
    doActionsAsync,
    doRatesAsync,
    uploadFileDCToBoondAsync,
    doHighRatesAsync,
    sendEmailErrorSendBoond,
    resendDoActionsAsync,
    sendActivityAreas
};
